<template>
  <div class="signup-page">
    <img class="layout__q-logo" src="/images/logo-small.svg" />
    <div class="signup-page-login">
      <div class="signup-page-login__logo">
          <img
            class="signup-page-login__logo__img"
            :src="`/images/logo.svg`"
            alt="OWQLO"
          />
      </div>
      <app-i18n class="signup-page-login__title" code="auth.signupText" />

      <div class="signup-page-login__title-separator" />
      <el-form
        :model="model"
        :rules="rules"
        @keypress.enter.native="doSubmit"
        @submit.prevent.native="doSubmit"
        class="signup-page-login__form"
        ref="form"
        v-if="model"
      >
        <el-row>
          <!-- Email -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item :prop="fields.email.name">
              <el-input
                :placeholder="i18n('auth.fields.email')"
                prefix-icon="icon-mail"
                :disabled="!!defaultEmail"
                auto-complete="off"
                ref="focus"
                v-model="model[fields.email.name]"
              />
            </el-form-item>
          </el-col>

          <!-- Password -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item :prop="fields.password.name">
              <el-input
                :placeholder="i18n('auth.fields.password')"
                auto-complete="off"
                class="el-input--password"
                prefix-icon="icon-lock"
                show-password
                type="password"
                v-model="model[fields.password.name]"
              />
            </el-form-item>
          </el-col>

          <!-- Confirm Password -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item :prop="fields.confirmPassword.name">
              <el-input
                :placeholder="i18n('auth.fields.confirmPassword')"
                auto-complete="off"
                class="el-input--password"
                prefix-icon="icon-lock"
                show-password
                type="password"
                v-model="model[fields.confirmPassword.name]"
              />
            </el-form-item>
          </el-col>

          <!-- Form controls -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item class="signup-page-login__form__controls">
              <el-button :loading="loading" @click="doSubmit" type="primary">
                <app-i18n code="auth.signup" />
              </el-button>
            </el-form-item>
          </el-col>

          <!-- Sign up -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item class="signup-page-login__form__sign-in">
              <div class="signup-page-login__form__sign-in__wrapper">
                <app-i18n code="auth.alreadyHaveAnAccount" />
                <router-link :to="{ path: '/auth/signin' }">
                  <app-i18n class="signup-page-login__form__sign-in__link" code="auth.signin" />
                </router-link>
              </div>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { UserModel } from '@modules/auth/user-model';
import { i18n } from '@shared/i18n';

export default {
  name: 'app-signup-page',

  data() {
    return {
      model: {},
    };
  },

  beforeRouteEnter(to, from, next) {
    if (!to.query.email) {
      next({ name: 'signin' });
    } else {
      next()
    }
  },

  computed: {
    ...mapGetters({
      loading: 'auth/loading',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),
    defaultEmail() {
      return this.$route.query.email || null;
    },
    rules() {
      const { fields } = this;
      var validatePassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(i18n('auth.passwordAgain')));
        } else if (value !== this.model.password) {
          callback(new Error(i18n('auth.passwordNotMatch')));
        } else {
          callback();
        }
      };
      
      return {
        email: fields.email.forFormRules(),
        password: fields.password.forFormRules(),
        confirmPassword: [
          { validator: validatePassword }
        ]
      };
    },
    fields() {
      const { dateFormat, timeFormat} = this;
      return new UserModel({
        dateFormat, timeFormat
      }).fields();
    },
  },
  created() {
    if (this.defaultEmail) {
      this.model.email = this.defaultEmail;
    }
  },

  methods: {
    ...mapActions({
      doRegisterEmailAndPassword:
        'auth/doRegisterEmailAndPassword',
    }),

    async doSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      await this.doRegisterEmailAndPassword({
        email: this.model.email,
        password: this.model.password,
      });
      
    },

    i18n(code) {
      return i18n(code);
    },
  },
};
</script>

<style lang="scss" scoped>

.signup-page .layout__q-logo {
  width: 800px;
}

.signup-page-login {
  @include auth-mixin;

  background-color: white;
  position: absolute;
  width: 754px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
  padding-top: 4em;

  &__form {
    width: 350px;

    &__sign-in {
      &__link {
        margin-left: 5px;
        color: #2acccc;
        font-weight: bold;
      }
    }

    @include mobile {
      width: 300px;
    }
  }
  @include small-mobile {
    padding-top: 6em;
  }
  @include mobile {
    width: 100vw;
    height: 100vh;
    display: grid;
    align-content: center;
  }
}
</style>